export default __webpack_public_path__ + "static/media/t-dispatch-logo-2.1745dec6.svg";